export default function isOpenNow(timezone, openingHours) {

    if(!openingHours) return true;
    const now = new Date().toLocaleString("en-US", {timeZone: timezone});
    const currentDay = new Date().toLocaleString("en-US", {timeZone: timezone, weekday:"long"});

    const todayOpeningHours = openingHours.find(hour => hour.day === currentDay);
    if (!todayOpeningHours) {
        return true;
    }

    const openHour = convertTime(todayOpeningHours.open).split(':')[0]
    const openMinute = convertTime(todayOpeningHours.open).split(':')[1]

    const closeHour = convertTime(todayOpeningHours.close).split(':')[0]
    const closeMinute = convertTime(todayOpeningHours.close).split(':')[1]

    const openTime = new Date()
    openTime.setHours(Number(openHour))
    openTime.setMinutes(Number(openMinute))
    const closeTime = new Date()
    closeTime.setHours(Number(closeHour));
    closeTime.setMinutes(Number(closeMinute));

    const currentTime = new Date(now)

    return currentTime >= openTime && currentTime <= closeTime;
}
function convertTime (time12HourFormat){
    if(!time12HourFormat) return '';
    const [time, period] = time12HourFormat.split(' ');
    const [hours, minutes] = time.split(':').map(Number);

    let hours24 = hours;
    if (period.toLowerCase() === 'p.m.' && hours !== 12) {
        hours24 += 12;
    } else if (period.toLowerCase() === 'a.m.' && hours === 12) {
        hours24 = 0;
    }

    const hoursString = hours24.toString().padStart(2, '0');
    const minutesString = minutes.toString().padStart(2, '0');

    return `${hoursString}:${minutesString}`;
}